import React, { JSX } from "react";
import { Route, Switch } from "react-router";
import Page404 from "go-app/components/Page404/Page404";
import OrganizationLiveOrdersTableIndexPage from "./pages/Index";

const OrganizationLiveOrdersTablePage = (): JSX.Element => {
	return (
		<Switch>
			<Route component={OrganizationLiveOrdersTableIndexPage} />
			<Route component={Page404} />
		</Switch>
	);
};

export default OrganizationLiveOrdersTablePage;
